import * as visit from 'unist-util-visit';
import * as removeNode from 'unist-util-remove';
const STANDALONE_LINK_TYPE = 'mfStandaloneLink';
const MF_BLOCKQUOTE = 'mfBlockquote';
const MF_LIST = 'mfList';
export class Parsers {
    /**
     * Given a node that contains a paragraph as first node, it will ease the handling of the keywords.
     * Keywords are specified with the syntax {?keyword1|keyword2}. The keywordHandler callback
     * will run once for each keyword.
     * After the handle of the keywords, we strip them out of the AST.
     *
     * @param tree The tree that is being visited
     * @param node The node containing a paragraph as first node
     * @param keywordHandler Lambda (keyword) => () that will be run for each keyword that has been parsed
     */
    static handleKeywordsOfNode(tree, node, keywordHandler) {
        if (node.children.length > 0 && node.children[0].type == 'paragraph') {
            const paragraph = node.children[0];
            if (paragraph.children.length > 0 &&
                paragraph.children[0].type == 'text') {
                const textNode = paragraph.children[0];
                const keywords = this.extractKeywords(textNode.value);
                keywords.forEach(k => {
                    keywordHandler(k);
                });
                const cleaned = this.stripTextFromKeywords(textNode.value);
                if (cleaned != '') {
                    textNode.value = cleaned;
                }
                else if (paragraph.children.length > 1) {
                    removeNode(tree, textNode);
                }
                else if (paragraph.children.length == 1 && node.children.length > 1) {
                    removeNode(tree, paragraph);
                }
                else if (paragraph.children.length == 1 &&
                    node.children.length == 1) {
                    removeNode(tree, node);
                }
            }
        }
    }
    static extractKeywords(text) {
        const match = text.match(this.KEYWORD_MATCHER);
        if (!match) {
            return [];
        }
        return match[1].split('|');
    }
    static stripTextFromKeywords(text) {
        return text.replace(this.KEYWORD_MATCHER, '');
    }
}
Parsers.StandaloneLink = () => (tree, file) => {
    const visitor = node => {
        const { children } = node;
        if (children.length === 1 && children[0].type == 'link') {
            const link = children[0];
            link.type = STANDALONE_LINK_TYPE;
        }
    };
    visit(tree, 'paragraph', visitor);
};
Parsers.Blockquote = () => (tree, file) => {
    const visitor = node => {
        node.type = MF_BLOCKQUOTE;
        node.alertType = 'info';
        Parsers.handleKeywordsOfNode(tree, node, keyword => {
            switch (keyword) {
                case 'success':
                    node.alertType = 'success';
                    break;
                case 'warning':
                    node.alertType = 'warning';
                    break;
                case 'error':
                    node.alertType = 'error';
                    break;
                case 'loading':
                    node.alertType = 'loading';
                    break;
            }
        });
    };
    visit(tree, 'blockquote', visitor);
};
Parsers.List = () => (tree, file) => {
    const visitor = node => {
        const listItems = node.children;
        node.type = MF_LIST;
        node.tickmark = false;
        if (listItems.length > 0) {
            const firstListItem = listItems[0];
            Parsers.handleKeywordsOfNode(tree, firstListItem, keyword => {
                switch (keyword) {
                    case 'tickmark':
                        node.tickmark = true;
                        break;
                }
            });
        }
    };
    visit(tree, 'list', visitor);
};
Parsers.KEYWORD_MATCHER = /\{\?(.+)\} ?/;
//# sourceMappingURL=Parsers.js.map